/* Visual-only enhancement: move, never duplicate, the existing product H1. */
(() => {
  'use strict';
  if (window.__gnwVisualV2) return;
  window.__gnwVisualV2 = true;
  const registrations = new Map();

  const init = () => {
    document.querySelectorAll('[data-gnw-main-product]').forEach((root) => {
      if (registrations.has(root)) return;
      const host = root.querySelector('[data-gnw-mobile-title]');
      const title = root.querySelector('.product-block--header h1.product-single__title');
      if (!host || !title) return;
      const marker = document.createComment('GNW original product title position');
      title.before(marker);
      const mq = window.matchMedia('(max-width: 768px)');
      const sync = () => {
        if (!root.isConnected) return;
        if (mq.matches) {
          if (title.parentNode !== host) host.append(title);
        } else if (marker.parentNode) {
          marker.after(title);
        }
      };
      mq.addEventListener('change', sync);
      sync();
      registrations.set(root, () => {
        mq.removeEventListener('change', sync);
        if (marker.parentNode) marker.after(title);
        marker.remove();
      });
    });
    for (const [root, dispose] of registrations) {
      if (!root.isConnected) { dispose(); registrations.delete(root); }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, dispose] of registrations) {
      if (event.target === root || event.target.contains(root)) { dispose(); registrations.delete(root); }
    }
  });
})();
